"use client"
import { Box, Typography, Button, Container } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { Home } from "@mui/icons-material"

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          py: 8,
        }}
      >
        <Typography variant="h1" component="h1" gutterBottom>
          404
        </Typography>
        <Typography variant="h4" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </Typography>
        <Button variant="contained" startIcon={<Home />} onClick={() => navigate("/dashboard")} sx={{ mt: 4 }}>
          Back to Dashboard
        </Button>
      </Box>
    </Container>
  )
}

export default NotFound

